import { jsx as s } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as n } from "../../../../../external/preact/compat/dist/compat.module.js";
import { useCallback as a } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { useResponsiveViewport as p, mediaQueries as C } from "../../../../../hooks/useResponsiveViewport.js";
import { renderDefaultSingleSelectionCheckedness as d } from "../components/SelectListItem.js";
/* empty css                            */
import { Fragment as _ } from "../../../../../external/preact/dist/preact.module.js";
import f from "../Select.js";
const o = "adyen-pe-balance-account-selector", S = `${o}__account-id`, c = `${o}__account-label`, A = n(
  ({
    activeBalanceAccount: r,
    balanceAccountSelectionOptions: m,
    onBalanceAccountSelection: t
  }) => {
    const i = p(C.down.xs), l = a(
      (e) => /* @__PURE__ */ s(_, { children: [
        /* @__PURE__ */ s("div", { className: e.contentClassName, children: [
          e.item.name && /* @__PURE__ */ s("span", { className: c, children: e.item.name }),
          /* @__PURE__ */ s("span", { className: S, children: e.item.id })
        ] }),
        d(e)
      ] }),
      []
    );
    return m && m.length > 1 ? /* @__PURE__ */ s(
      f,
      {
        popoverClassNameModifiers: [o],
        onChange: t,
        filterable: !1,
        multiSelect: !1,
        selected: r == null ? void 0 : r.id,
        withoutCollapseIndicator: !0,
        items: m,
        renderListItem: l,
        showOverlay: i
      }
    ) : null;
  }
);
export {
  A as default
};
